export const isEmbedded = () => window.parent !== window

export function postToParent(message: Record<string, unknown>) {
  if (!isEmbedded()) return
  try { window.parent.postMessage(message, '*') } catch {}
}

export function observeHeight(element: HTMLElement) {
  if (!isEmbedded() || typeof ResizeObserver === 'undefined') return () => {}
  const observer = new ResizeObserver(() => {
    postToParent({ type: 'bizzey:booking:resize', height: Math.ceil(element.getBoundingClientRect().height) })
  })
  observer.observe(element)
  return () => observer.disconnect()
}
